import { render, staticRenderFns } from "./GlossaryLink.vue?vue&type=template&id=f82f40ac&scoped=true"
import script from "./GlossaryLink.vue?vue&type=script&lang=js"
export * from "./GlossaryLink.vue?vue&type=script&lang=js"
import style0 from "./GlossaryLink.vue?vue&type=style&index=0&id=f82f40ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f82f40ac",
  null
  
)

export default component.exports